import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-view-button',
  templateUrl: './change-view-button.component.html',
  styleUrls: ['./change-view-button.component.scss']
})
export class ChangeViewButtonComponent implements OnInit {
  @Output()
  showDetails = new EventEmitter<boolean>();
  showingDetails: boolean;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {}

  getLabel(): string {
    let label: string;
    if (this.showingDetails) {
      label = this.translateService.instant('reports.summary-label');
      return `<< ${label}`;
    } else {
      label = this.translateService.instant('reports.full-statistics');
      return `${label} >>`;
    }
  }

  changeView() {
    this.showingDetails = !this.showingDetails;
    this.showDetails.emit(this.showingDetails);
  }
}
